// extracted by mini-css-extract-plugin
module.exports = {"addDependents":"AddDependentsCard_addDependents___tGGU","cta":"AddDependentsCard_cta__2pdjb"};